<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-credit-card"></i>
              Tarjeta
            </h6>
            <button type="button" class="form-card__btn" @click="modified">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">

            <div
              v-if="limited && header.pos != 0 && total >= 500000 && (header.letter === 'C' || header.letter === 'B')"
              class="alert alert-danger mb-3">
              Record&aacute; que para realizar una factura igual o mayor a $ 500.000 ten&eacute;s que informar a la ARCA todos los datos del cliente.
            </div>

            <!-- SUMMARY -->
            <div class="creditcard-summary">
              <div class="total-row total-final">
                <span class="label">Total a pagar</span>
                <span class="value">$ {{ round(total, 2) }}</span>
              </div>
              <div v-for="creditcard in payarray.creditcards" :key="'cc-' + creditcard.coupon" class="total-row">
                <span class="label">{{creditcard.name}} — cup&oacute;n {{creditcard.coupon}}</span>
                <span class="value">$ {{ round(creditcard.amount, 2) }}</span>
              </div>
              <div v-if="totalInterest > 0" class="total-row">
                <span class="label">Inter&eacute;s</span>
                <span class="value">$ {{ round(totalInterest, 2) }}</span>
              </div>
              <div v-if="limited && diference != 0" class="total-row">
                <span class="label">Diferencia</span>
                <span class="value text-danger">$ {{ round(diference, 2) }}</span>
              </div>
            </div>

            <div class="totals-divider"></div>

            <!-- CREDIT CARD FORM -->
            <div class="payment-methods__child mt-1">
              <credit-card
                :locked="payarray.creditcards.length > 0"
                :default-amount="total"
                v-on:creditcardcancel="creditCardRemove"
                v-on:creditcardsaved="creditCardSave"/>
            </div>

          </div>

          <div class="form-card__footer">
            <button v-if="limited" type="button" class="form-card__btn" @click="modified">Cancelar</button>
            <button
              type="button"
              class="form-card__btn form-card__btn--primary"
              :disabled="!(round(diference, 2) == 0) || (payarray.creditcards.length == 0)"
              @click="finishReceipt">
              <i class="bi bi-check-lg"></i>
              Finalizar venta
            </button>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import creditCard from './Credit-card.vue';

export default {
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault', 'genType'],
  data: function() {
    return {
      totalpayed: 0,
      diference: 0,
      payarray: {
        banks: [],
        cash: 0,
        fund_id: 0,
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: []
      },
    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    this.payarray.banks = [{ amount: 0 }];
    this.payarray.fundBanks_id = [{ fund: 0 }];
    this.calc();
  },
  computed: {
    totalInterest() {
      return this.payarray.creditcards
        .map(el => parseFloat(el.interest))
        .reduce((acc, currentValue) => acc + currentValue, 0);
    }
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    }
  },
  methods: {
    round: function(value, decimals) {
      return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
    },
    calc: function () {
      this.totalpayed = 0;

      var interestCreditCards = this.payarray.creditcards.map(el => parseFloat(el.interest)).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalCreditCards = this.payarray.creditcards.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);

      this.totalpayed = this.round(totalCreditCards, 2) + this.round(interestCreditCards, 2);
      this.diference = this.round(this.total, 2) - this.round(this.totalpayed, 2);
    },
    creditCardSave: function(obj) {
      if (this.payarray.creditcards.length > 0) {
        alert('Ya hay un cupón cargado. Quitalo con el botón X si querés cambiarlo.');
        return;
      }
      this.payarray.creditcards.push(Object.assign({}, obj));
    },
    creditCardRemove: function() {
      if (this.payarray.creditcards.length > 0) {
        this.payarray.creditcards.splice(0, 1);
      }
    },
    modified: function () {
      this.$emit('paymentmethodschanged', {});
      this.$emit('close');
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose', this.payarray);
      this.$emit('close');
    },
  },
  components: {
    creditCard
  }
}
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 880px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.payment-methods__child {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 16px;
  background: var(--surface-subtle);
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
